var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger hamburger--collapse",class:{ 'is-active': _vm.isOpen },attrs:{"type":"button"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])
}]

export { render, staticRenderFns }